import { openBlock as l, createElementBlock as e, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, a = /* @__PURE__ */ t("path", {
  fill: "currentColor",
  stroke: "currentColor",
  "stroke-width": ".75",
  d: "M4.406 6.844h-.375v2.691l.346.026A2.47 2.47 0 0 0 7.031 7.24l.022-.396H4.406Zm-.375 9.937v.375h3.022l-.022-.396a2.467 2.467 0 0 0-2.654-2.321l-.346.026v2.316Zm15.563.375h.375v-2.7l-.357-.018a2.467 2.467 0 0 0-2.586 2.321l-.023.397h2.591Zm-.013-3.375.388.013v-3.588l-.388.013a3.113 3.113 0 0 1-3.212-3.012l-.012-.363H7.643l-.012.363a3.113 3.113 0 0 1-3.212 3.012l-.388-.013v3.588l.388-.013a3.114 3.114 0 0 1 3.212 3.012l.012.363h8.714l.012-.363a3.11 3.11 0 0 1 3.212-3.012Zm.032-4.219.356-.018v-2.7h-2.966l.023.396a2.47 2.47 0 0 0 2.587 2.322ZM11.988 9h.024a3.113 3.113 0 0 1 3.213 3 3.11 3.11 0 0 1-3.213 3h-.024a3.11 3.11 0 0 1-3.213-3 3.11 3.11 0 0 1 3.213-3Zm-2.556 2.978L9.43 12v.022a2.47 2.47 0 0 0 2.564 2.322 2.467 2.467 0 0 0 2.63-2.323v-.042a2.467 2.467 0 0 0-2.63-2.323 2.467 2.467 0 0 0-2.563 2.322Zm-5.026-5.79h15.188a1.03 1.03 0 0 1 1.031 1.03v9.563a1.03 1.03 0 0 1-1.031 1.032H4.406a1.03 1.03 0 0 1-1.031-1.032V7.22a1.03 1.03 0 0 1 1.031-1.032Z"
}, null, -1), r = [
  a
];
function n(h, c) {
  return l(), e("svg", o, [...r]);
}
const v = { render: n };
export {
  v as default,
  n as render
};
